/**
 * AISuggestionsModal - Sugestoes IA - extraído VERBATIM de ProductsContent.js (Fase 2 refactor).
 * Recebe estado/handlers via props do closure de ProductsContent.
 */
import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const AISuggestionsModal = ({
  showAISuggestionsModal,
  setShowAISuggestionsModal,
  aiSuggestions,
  applyAISuggestions,
  applyingSuggestions,
  selectedSuggestions,
  toggleAllSuggestions,
  toggleSuggestion,
}) => {
  return (
      <Dialog open={showAISuggestionsModal} onOpenChange={setShowAISuggestionsModal}>
        <DialogContent className="bg-gray-900 border border-gray-800 max-w-2xl max-h-[85vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="text-white text-xl flex items-center gap-2">
              <Sparkles size={22} className="text-purple-400" />
              Sugestões da IA para Vincular Imagens
            </DialogTitle>
            <p className="text-gray-400 text-sm">
              Analise as sugestões e selecione quais deseja aplicar
            </p>
          </DialogHeader>
          
          <div className="flex-1 overflow-y-auto space-y-3 pr-2" style={{ maxHeight: '50vh' }}>
            {aiSuggestions.length === 0 ? (
              <div className="text-center py-8 text-gray-400">
                <Sparkles size={40} className="mx-auto mb-3 opacity-30" />
                <p>Nenhuma sugestão disponível</p>
              </div>
            ) : (
              <>
                {/* Toggle All */}
                <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg border border-gray-700">
                  <span className="text-gray-300 font-medium">Selecionar todas</span>
                  <input
                    type="checkbox"
                    checked={Object.values(selectedSuggestions).every(v => v)}
                    onChange={(e) => toggleAllSuggestions(e.target.checked)}
                    className="w-5 h-5 rounded bg-gray-700 border-gray-600 text-purple-500 focus:ring-purple-500"
                  />
                </div>

                {/* Lista de Sugestões */}
                {aiSuggestions.map((suggestion) => (
                  <div
                    key={suggestion.product_id}
                    className={`p-3 rounded-lg border transition-all cursor-pointer ${
                      selectedSuggestions[suggestion.product_id]
                        ? 'bg-purple-500/10 border-purple-500/50'
                        : 'bg-gray-800/30 border-gray-700 hover:border-gray-600'
                    }`}
                    onClick={() => toggleSuggestion(suggestion.product_id)}
                  >
                    <div className="flex items-start gap-3">
                      {/* Checkbox */}
                      <input
                        type="checkbox"
                        checked={selectedSuggestions[suggestion.product_id] || false}
                        onChange={() => toggleSuggestion(suggestion.product_id)}
                        className="w-5 h-5 mt-1 rounded bg-gray-700 border-gray-600 text-purple-500 focus:ring-purple-500"
                        onClick={(e) => e.stopPropagation()}
                      />
                      
                      {/* Imagem sugerida */}
                      <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-gray-800">
                        <img
                          src={suggestion.image_url}
                          alt={suggestion.image_name}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.src = "https://res.cloudinary.com/df9ady2jx/image/upload/v1766408761/pedi-facil/default-product-image.jpg";
                          }}
                        />
                      </div>
                      
                      {/* Info */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <span className="text-white font-medium truncate">{suggestion.product_name}</span>
                          <span className="text-gray-500">→</span>
                          <span className="text-purple-400 truncate">{suggestion.image_name}</span>
                        </div>
                        {suggestion.product_description && (
                          <p className="text-gray-500 text-sm truncate mt-1">{suggestion.product_description}</p>
                        )}
                        <div className="flex items-center gap-2 mt-1">
                          <span className={`text-xs px-2 py-0.5 rounded ${
                            suggestion.confidence >= 80 ? 'bg-green-500/20 text-green-400' :
                            suggestion.confidence >= 60 ? 'bg-yellow-500/20 text-yellow-400' :
                            'bg-red-500/20 text-red-400'
                          }`}>
                            {suggestion.confidence}% confiança
                          </span>
                          {suggestion.reason && (
                            <span className="text-xs text-gray-500">{suggestion.reason}</span>
                          )}
                        </div>
                        {/* Tags */}
                        {suggestion.image_tags && suggestion.image_tags.length > 0 && (
                          <div className="flex flex-wrap gap-1 mt-1">
                            {suggestion.image_tags.slice(0, 4).map((tag, i) => (
                              <span key={i} className="text-xs px-1.5 py-0.5 bg-gray-700 text-gray-400 rounded">
                                {tag}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          
          {/* Rodapé com ações */}
          <div className="flex gap-3 pt-4 border-t border-gray-800">
            <button
              onClick={() => setShowAISuggestionsModal(false)}
              className="flex-1 px-4 py-2 text-gray-400 hover:text-white border border-gray-700 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={applyAISuggestions}
              disabled={applyingSuggestions || Object.values(selectedSuggestions).filter(v => v).length === 0}
              className="flex-1 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {applyingSuggestions ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Aplicando...
                </>
              ) : (
                <>
                  <Check size={16} />
                  Aplicar {Object.values(selectedSuggestions).filter(v => v).length} selecionadas
                </>
              )}
            </button>
          </div>
        </DialogContent>
      </Dialog>

  );
};

export default AISuggestionsModal;
